import { Segment } from "semantic-ui-react";

import React from "react";
import { useDropzone } from "react-dropzone";

export default function Dropzone({ accept, children, style, onDropFiles }) {
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		accept,
		disabled: !accept,
		onDrop: onDropFiles,
	});

	return (
		<Segment
			placeholder
			textAlign="center"
			style={{
				opacity: isDragActive ? 1 : 0.6,
				cursor: "pointer",
				...style,
			}}
			{...getRootProps({ className: "dropzone" })}
		>
			{children}

			{accept && <input {...getInputProps()} />}
		</Segment>
	);
}
